// extracted by mini-css-extract-plugin
export default {"container_inputs":"styles_container_inputs__hFcIW","buttons":"styles_buttons__OY2Cb","buttons_actions":"styles_buttons_actions__3aNnk"};